// src/firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: 'AIzaSyC4AuMCDZYmeBQFM-YVTcf_GA1s_xmT__A',
  authDomain: 'taskfino-34f37.firebaseapp.com',
  projectId: 'taskfino-34f37',
  storageBucket: 'taskfino-34f37.appspot.com',
  messagingSenderId: '532298794852',
  appId: '1:532298794852:web:0733784da528ac7f5f5c71',
  measurementId: 'G-N1QN6JCCY5',
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

// Request permission and get token
export async function requestNotificationPermission() {
  try {
    // Check if notifications are supported
    if (!('Notification' in window)) {
      console.warn('This browser does not support notifications');
      return null;
    }

    // Check current permission
    let permission = Notification.permission;
    console.log('Current permission:', permission);

    // If already denied, don't ask again (browsers block repeated prompts)
    if (permission === 'denied') {
      console.warn('Notifications were previously denied');
      return null;
    }

    // If not granted, request permission
    if (permission !== 'granted') {
      permission = await Notification.requestPermission();
      console.log('User response:', permission);
    }

    // If still not granted, exit
    if (permission !== 'granted') {
      return null;
    }

    // Proceed with FCM token generation
    const swRegistration = await navigator.serviceWorker.ready;
    const currentToken = await getToken(messaging, {
      vapidKey: 'BGfgXAzKP75OVPiDXYW9Dh160yX26xrA5F-RYA3rUza8dlxV4j3yKVGwhiuwTUYwpOu7Vp8dsTfFYW4CFxdiXTc',
      serviceWorkerRegistration: swRegistration,
    });

    return currentToken || null;
  } catch (err) {
    console.error('FCM Token Error:', err);
    return null;
  }
}

export { messaging, onMessage };
